import { Modal } from "antd";
import React, { useState } from "react";
// import { NewAddressForm } from "./NewAddressForm";
// import { Form } from "antd";
// import React, { useEffect } from "react";
import { Form, Input } from "antd";
import { DataSource, emptyUUID, HrCountryId } from "../../../../models/enums";
import { MultiLevelSelector } from "../../../../components/FormControls";
import { selectUserInfo } from "../../../../routes/Auth/auth.ducks";
import { useSelector } from "react-redux";
import styles from "./sendAddressModal.scss"
import { api } from "../../../../services";
import ReactGA from "react-ga4";

const locationValidator = {
  validator: (rule, value, callback) => {
    if (!value || !value.countryId || value.countryId === emptyUUID) {
      return callback("Odaberite sve razine");
    }

    if (
      value.countryId === HrCountryId && (
        (!value.countyId || value.countyId === emptyUUID) ||
        (!value.cityId || value.cityId === emptyUUID) ||
        (!value.settlementId || value.settlementId === emptyUUID)
      )) {

      return callback("Odaberite sve razine");
    }

    callback();
  }
};


export const NewAddressModalComponent = ({ visible, handleClose, form, fetchAddresses }) => {
  const userInfo = useSelector(selectUserInfo)
  const [loading, setLoading] = useState(false)


  const handleSubmit = async (values) => {
    setLoading(true)

    const newAddress = {
      fullName: values.fullName,
      countryId: values.location.countryId,
      countyId: values.location.countyId,
      cityId: values.location.cityId,
      settlementId: values.location.settlementId,
      street: values.street,
      zipCode: values.zipCode,
      vatInvoiceLegalEntityName: values.vatInvoiceLegalEntityName,
      phoneNumber: values.phoneNumber,
      houseNumber: values.houseNumber
    }

    try {
      const response = await api.UserAddress.post(newAddress);

      ReactGA.event({
        category: "Inbox",
        action: "Click",
        label: "Sačuvana nova adresa"
      });


      fetchAddresses(response.id)
      handleClose()
    } catch (error) { }

  }


  const handleOk = () => {
    form.validateFields((err, values) => {
      if (!err) {
        handleSubmit(values)
      }
    })
  }

  return (
    <div>

      <Modal
        visible={visible}
        onCancel={handleClose}
        title="Dodaj novu adresu"
        cancelText="Natrag"
        onOk={handleOk}
        okButtonProps={{
          disabled: loading
        }}
        width="50%"
        centered
        bodyStyle={{ maxHeight: "calc(100dvh - 200px)", overflowY: "auto" }}
      >

        <div>
          <Form>
            <div style={{ display: "flex", gap: 14 }}>

              <div className={styles.formItem}>
                <span className="control-title required">Ime i prezime</span>
                <Form.Item>
                  {form.getFieldDecorator("fullName", {
                    rules: [{
                      required: true,
                      message: "Molimo, unesite ime i prezime"
                    }]
                  })(
                    <Input placeholder="Unesite ime i prezime" />
                  )}
                </Form.Item>
              </div>
              <div className={styles.formItem}>
                <span className="control-title">Naziv tvrtke</span>
                <Form.Item>
                  {form.getFieldDecorator("vatInvoiceLegalEntityName")(
                    <Input placeholder="Unesite naziv tvrtke" />
                  )}
                </Form.Item>
              </div>
            </div>
            <Form.Item>
              {form.getFieldDecorator(DataSource.location, {
                initialValue: !userInfo.countryId
                  ? undefined
                  : {
                    countryId: userInfo.countryId,
                    cityId: userInfo.cityId,
                    countyId: userInfo.countyId,
                    settlementId: userInfo.settlementId
                  },
                rules: [locationValidator]
              })(
                <MultiLevelSelector
                  title="location"
                  isRequired
                  dataSource={DataSource.location}
                  className={styles.multiLevelSelector}
                  getPopupContainer={trigger => trigger.parentNode}
                  child={{
                    title: "Država",
                    field: "countryId",
                    placeholder: "Država",
                    child: {
                      title: "Županija",
                      field: "countyId",
                      placeholder: "Županija",
                      child: {
                        title: "Grad",
                        field: "cityId",
                        placeholder: "Grad",
                        child: {
                          title: "Naselje",
                          field: "settlementId",
                          placeholder: "Naselje"
                        }
                      }
                    }
                  }}
                />
              )}

            </Form.Item>
            <div style={{ display: "flex", gap: 14 }}>

              <div className={styles.formItem}>
                <span className="control-title required">Ulica</span>
                <Form.Item>
                  {form.getFieldDecorator("street", {
                    rules: [{
                      required: true,
                      message: "Molimo, unesite ulicu"
                    }]
                  })(
                    <Input placeholder="Unesite ulicu" />
                  )}
                </Form.Item>
              </div>
              <div className={styles.formItem}>
                <span className="control-title required">Kućni broj</span>
                <Form.Item>
                  {form.getFieldDecorator("houseNumber", {
                    rules: [{
                      required: true,
                      message: "Molimo, unesite kućni broj"
                    }]
                  })(
                    <Input placeholder="Unesite kućni broj" />
                  )}
                </Form.Item>
              </div>
            </div>
            <div style={{ display: "flex", gap: 14 }}>

              <div className={styles.formItem}>
                <span className="control-title required">Poštanski broj</span>
                <Form.Item>
                  {form.getFieldDecorator("zipCode", {
                    rules: [{
                      required: true,
                      message: "Molimo, unesite poštanski broj"
                    }]
                  })(
                    <Input placeholder="Unesite poštanski broj" />
                  )}
                </Form.Item>
              </div>
              <div className={styles.formItem}>
                <span className="control-title required">Broj telefona</span>
                <Form.Item>
                  {form.getFieldDecorator("phoneNumber", {
                    rules: [{
                      required: true,
                      message: "Molimo, unesite broj telefona"
                    }]
                  })(
                    <Input placeholder="Unesite broj telefona" />
                  )}
                </Form.Item>
              </div>
            </div>
          </Form>
        </div>

      </Modal>
    </div>
  )
}


export const NewAddressModal = Form.create()(NewAddressModalComponent)


// WEBPACK FOOTER //
// ./src/containers/ChatsPage/SingleChat/SendAddressModal/NewAddressModal.tsx